import { createContext as e } from "react";
const t = /* @__PURE__ */ e(void 0), o = /* @__PURE__ */ e(void 0), i = /* @__PURE__ */ e(void 0);
export {
  t as D,
  o as a,
  i as b
};
//# sourceMappingURL=dialog-context-a736b58f.js.map
